<template>
  <v-container fluid>
    <v-col cols="12" sm="12" offset-sm="0">
      <v-card class="maincard" :loading="loading">
        <v-container fluid>
          <v-row align="center">
            <v-col cols="12" xs="12" sm="6">
              <v-card-title>Bestellungen</v-card-title>
            </v-col>

            <v-col cols="12" xs="12" sm="" style="text-align: right">
              <v-btn
                v-show="checkAccess(userRoles.userRole.SuperUser)"
                color="orange"
                @click="recalcPrices"
                class="mr-4"
                >Preise berechnen</v-btn
              >
              <v-btn color="secondary" @click="showExportDialog"
                >Exportieren</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
        <v-container fluid>
          <v-card>
            <v-container fluid>
              <v-card dense outlined class="pa-4">
                <v-row dense>
                  <v-col>
                    <CustomerSelectbox
                      v-if="checkAccess(userRoles.userRole.Manager)"
                      :showAll="true"
                      hide-details
                      dense
                      v-model="orderFilter.customer"
                      @input="findByFilter"
                    />
                    <UserSelectbox
                      v-else-if="checkAccess(userRoles.userRole.CustomerAdmin)"
                      :showAll="true"
                      hide-details
                      dense
                      v-model="orderFilter.user"
                      @input="findByFilter"
                    />
                  </v-col>

                  <v-col sm="3">
                    <v-select
                      dense
                      hide-details
                      label="Status"
                      :items="statusItems"
                      v-model="orderFilter.status"
                      @input="findByFilter"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center" class="mt-2">
                  <v-col cols="12" xs="12" sm="3">
                    <v-btn-toggle
                      color="green"
                      mandatory
                      v-model="orderFilter.lieferDatum"
                      @change="findByFilter"
                    >
                      <v-btn :value="false" small>Bestelldatum</v-btn>
                      <v-btn :value="true" small>Lieferdatum</v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-col cols="12" xs="12" sm="3">
                    <MenuDatePicker
                      :label="
                        orderFilter.lieferDatum
                          ? 'Lieferdatum Start'
                          : 'Bestelldatum Start'
                      "
                      dense
                      hide-details
                      locale="de-de"
                      :first-day-of-week="1"
                      v-model="orderFilter.startdate"
                      @input="findByFilter"
                    />
                  </v-col>
                  <v-col cols="12" sm="3">
                    <MenuDatePicker
                      :label="
                        orderFilter.lieferDatum
                          ? 'Lieferdatum Ende'
                          : 'Bestelldatum Ende'
                      "
                      dense
                      hide-details
                      locale="de-de"
                      :first-day-of-week="1"
                      v-model="orderFilter.enddate"
                      @input="findByFilter"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
            <OrderList :items="orderList" />
          </v-card>
        </v-container>
      </v-card>
    </v-col>
    <v-dialog v-model="dlgExport" persistent max-width="600px">
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title>Bestellungen exportieren</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dlgExport = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-switch
                  color="green"
                  v-model="orderExportOptions.useHeaders"
                  label="Überschriften verwenden"
                ></v-switch>
              </v-col>
              <v-col>
                <v-switch
                  color="green"
                  v-model="orderExportOptions.cumulate"
                  :disabled="orderExportOptions.dailyExport"
                  label="Daten kumulieren"
                  v-if="checkAccess(userRoles.userRole.Manager)"
                  @click="toggleCumulate"
                ></v-switch>
              </v-col>
              <v-col>
                <v-switch
                  color="green"
                  v-model="orderExportOptions.dailyExport"
                  label="Tagesexport"
                  @click="toggleDailyExport"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row v-if="checkAccess(userRoles.userRole.Manager)">
              <v-col>
                <v-switch
                  v-if="checkAccess(userRoles.userRole.Manager)"
                  :disabled="!orderExportOptions.cumulate"
                  color="green"
                  v-model="orderExportOptions.slaformat"
                  label="SLA Ausgabeformat"
                  @click="toggleSLAFormat"
                >
                </v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <MenuDatePicker
                  :label="
                    orderExportOptions.lieferDatum
                      ? 'Start Lieferdatum'
                      : 'Start Bestelldatum'
                  "
                  hide-details
                  locale="de-de"
                  :first-day-of-week="1"
                  v-model="orderExportOptions.startdate"
                  @input="startDateChanged"
                />
              </v-col>
              <v-col>
                <MenuDatePicker
                  :label="
                    orderExportOptions.lieferDatum
                      ? 'Ende Lieferdatum'
                      : 'Ende Bestelldatum'
                  "
                  hide-details
                  locale="de-de"
                  :first-day-of-week="1"
                  v-model="orderExportOptions.enddate"
                />
              </v-col>
              <v-col cols="12" sm="3">
                <v-select
                  v-model="orderExportOptions.delimiter"
                  hide-details
                  :items="delimiterOptions"
                  label="Trennzeichen"
                />
              </v-col>
            </v-row>
            <v-row v-if="checkAccess(userRoles.userRole.Manager)">
              <v-col>
                <v-btn-toggle
                  color="green"
                  mandatory
                  v-model="orderExportOptions.lieferDatum"
                >
                  <v-btn
                    :disabled="orderExportOptions.slaformat"
                    :value="false"
                    small
                    >Bestelldatum</v-btn
                  >
                  <v-btn :value="true" small>Lieferdatum</v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
            <v-row v-if="checkAccess(userRoles.userRole.Manager)">
              <v-col>
                <v-alert
                  v-show="orderExportOptions.cumulate"
                  type="warning"
                  colored-border
                  border="left"
                  outlined
                >
                  Achtung: Beim kumulierten Export mit dem Filter "Bestelldatum"
                  werden alle Bestellungen innerhalb des Suchzeitraums
                  zusammengezählt, daraus resultieren unterschiedliche
                  Lieferdatumsangaben.
                </v-alert>
              </v-col>
            </v-row>

            <v-card-actions class="mt-4">
              <v-btn color="red" outlined @click="dlgExport = false"
                >Abbrechen</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                v-show="orderExportOptions.slaformat"
                outlined
                dark
                color="green"
                @click="exportOrderToSLA"
                >In SLA importieren</v-btn
              >
              <v-btn dark color="green" @click="exportOrder">Exportieren</v-btn>
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src
import OrderList from "@/components/orders/OrderList";
import DataService from "@/services/DataService";
import OrderService from "@/services/OrderService";
import CustomerSelectbox from "@/components/customers/CustomerSelectbox";
import UserSelectbox from "@/components/users/UserSelectbox";
import MenuDatePicker from "@/components/MenuDatePicker";
import FileSaver from "file-saver";
import moment from "moment";

export default {
  name: "OrderMgmt",
  data: () => ({
    orderExportOptions: {
      startdate: null,
      enddate: null,
      delimiter: ";",
      useHeaders: true,
      cumulate: true,
      slaformat: false,
      dailyExport: false,
      lieferDatum: true
    },
    delimiterOptions: [",", ";", "#"],
    dlgExport: false,
    loading: false,
    statusItems: [
      { text: "Alle", value: "all" },
      { text: "Offen", value: "open" },
      { text: "Abgeschlossen", value: "saved" },
      { text: "Storniert", value: "canceled" }
    ]
  }),
  components: { OrderList, CustomerSelectbox, UserSelectbox, MenuDatePicker },
  methods: {
    toggleDailyExport() {
      this.orderExportOptions.cumulate = !this.orderExportOptions.dailyExport;
      this.toggleCumulate();
    },
    toggleSLAFormat() {
      if (this.orderExportOptions.slaformat) {
        this.orderExportOptions.lieferDatum = true;
      }
    },
    toggleCumulate() {
      if (
        !this.orderExportOptions.cumulate &&
        this.orderExportOptions.slaformat
      ) {
        this.orderExportOptions.slaformat = false;
      }
    },
    recalcPrices() {
      this.$store.commit("SET_APP_LOADING", true);
      DataService.apiClient
        .get("/order/recalc")
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Erfolgreich",
            text: "Preise upgedatet"
          });
        })
        .catch(error => {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message
          });
        })
        .finally(() => {
          this.$store.commit("SET_APP_LOADING", false);
        });
    },
    startDateChanged(date) {
      if (this.orderExportOptions.slaformat) {
        this.orderExportOptions.startdate = moment(date).isoWeekday(1);
        this.orderExportOptions.enddate = moment(date).isoWeekday(7);
      } else {
        this.orderExportOptions.enddate = moment(date)
          .endOf("month")
          .format("YYYY-MM-DD");
      }
    },
    findByFilter() {
      this.$store.commit("SET_APP_LOADING", true);

      this.$store
        .dispatch("order/fetchOrders")
        .then(() => {})
        .catch(error => {
          if (error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message
            });
          }
        })
        .finally(() => {
          this.$store.commit("SET_APP_LOADING", false);
        });
    },
    getAxiosInstance() {
      return DataService.apiClient;
    },
    showExportDialog() {
      this.dlgExport = true;
    },
    exportOrderToSLA() {
      this.$store.commit("SET_APP_LOADING", true);
      OrderService.exportToSLA(this.orderExportOptions)
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "success",
            title: "SLA Export",
            text: "Die Exportdatei wurde auf den SLA Server geladen"
          });
        })
        .catch(error => {
          if (error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message
            });
          }
        })
        .finally(() => {
          this.$store.commit("SET_APP_LOADING", false);
        });
    },
    exportOrder() {
      OrderService.fetchExport(this.orderExportOptions)
        .then(response => {
          let filename = "Bestellung_" + moment().format("YYYY-MM-DD") + ".csv";
          const blob = new Blob([response.data], {
            type: "text/csv;charset=utf-8"
          });

          FileSaver.saveAs(blob, filename);
          this.dlgExport = false;
        })
        .catch(error => {
          if (error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message
            });
          }
        });
    },
    loadCustomers() {
      let customers = this.$store.getters["customer/getCustomerList"];
      if (customers && customers.length == 0) {
        this.loading = true;
        this.$store
          .dispatch("customer/fetchCustomerList")
          .then(() => {
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            if (error.response.status != 401) {
              this.$notify({
                group: "dataline",
                type: "error",
                title: "Fehler",
                text: error.message
              });
            }
          });
      }
    },
    loadUsers() {
      let users = this.$store.getters["user/getUserList"];
      if (users && users.length == 0) {
        this.loading = true;
        this.$store
          .dispatch("user/fetchUserList")
          .then(() => {
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            if (error.response.status != 401) {
              this.$notify({
                group: "dataline",
                type: "error",
                title: "Fehler",
                text: error.message
              });
            }
          });
      }
    },
    checkAccess(role) {
      const user = this.$store.getters["user/getUser"];

      if (!user) {
        return false;
      }
      if (
        user.role === this.$store.getters["user/userRoles"].userRole.SuperUser
      ) {
        return true;
      } else if (user.role === role) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
    userRoles() {
      return this.$store.getters["user/userRoles"];
    },
    orderList() {
      let orders = this.$store.getters["order/getOrders"];
      /*    if (this.orderFilter.customer !== "all") {
        orders = orders.filter(
          (el) => el.customer._id === this.orderFilter.customer._id
        );
      }
      if (this.orderFilter.status !== "all") {
        orders = orders.filter((el) => el.status === this.orderFilter.status);
      }*/
      return orders;
    },
    orderFilter: {
      get() {
        return this.$store.getters["order/getOrderFilter"];
      },
      set(value) {
        this.$store.commit("order/SET_ORDER_FILTER", value);
      }
    },
    orderSearch: {
      get() {
        return this.$store.getters["order/getOrderSearch"];
      },
      set(value) {
        this.$store.commit("order/SET_ORDER_SEARCH", value);
      }
    }
  },
  beforeCreated() {},
  created() {
    this.loadCustomers();

    if (!this.checkAccess(this.userRoles.userRole.CustomerAdmin)) {
      this.orderExportOptions.startdate = moment()
        .isoWeek(moment().isoWeek() - 1)
        .format("YYYY-MM-DD");
      this.orderExportOptions.cumulate = false;
    } else if (this.checkAccess(this.userRoles.userRole.CustomerAdmin)) {
      this.loadUsers();
    }
  }
};
</script>
<style scoped></style>
